const t = {
  name: "ArrowRight",
  dimensions: { width: 24, height: 24 },
  content: `
<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M18.5859 12.9999L12.5859 18.9999L14.0002 20.4141L22.4144 11.9999L14.0002 3.58569L12.5859 4.99991L18.586 10.9999L2 10.9999L2 12.9999L18.5859 12.9999Z" fill="currentColor"/>
</svg>
  `
};
export {
  t as ArrowRight
};
